import BaseController from '..';
import { userInfo } from '../../../models/entities/user';

export type PlatformUsersListResponse = {
    data: userInfo[];
    total: number;
};

export default class PlatformUsersController extends BaseController {
    constructor(baseUrl: string) {
        super(baseUrl);
    }

    async fetchUsers(params?: { range?: [number, number]; filter?: Record<string, string> }): Promise<PlatformUsersListResponse> {
        const search = new URLSearchParams();
        if (params?.range) search.set('range', JSON.stringify(params.range));
        if (params?.filter) search.set('filter', JSON.stringify(params.filter));
        const qs = search.toString();
        return this.client.get(`/super-admin/users${qs ? `?${qs}` : ''}`);
    }

    async fetchUser(id: string): Promise<userInfo> {
        return this.client.get(`/super-admin/users/${id}`);
    }

    async createUser(payload: Record<string, unknown>): Promise<userInfo> {
        return this.client.post('/super-admin/users', JSON.stringify(payload));
    }

    async updateUser(id: string, payload: Record<string, unknown>): Promise<userInfo> {
        return this.client.put(`/super-admin/users/${id}`, JSON.stringify(payload));
    }
}
